module.exports = __WEBPACK_EXTERNAL_MODULE_31__;


//////////////////
// WEBPACK FOOTER
// external "@material/react-button/dist/index.js"
// module id = 31
// module chunks = 2 3